import React from 'react';
import { Link } from 'react-router-dom';
import { useAtom, useAtomValue } from 'jotai';
import { Button, Tabs, Tab, Box, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { matrixTabAtom } from 'atoms/Ltool/matrixAtoms';
import { AllConditionChart } from './subcomponents/AllConditionChart';
import { AllConditionMatrix } from './subcomponents/AllConditionMatrix';
import { stageConfigAtom } from 'atoms/Ltool/stageConfigAtoms';
import { DownloadMatrixCsvButton } from './subcomponents/DownloadMatrixCsvButton';
import { powertrainAtom } from 'atoms/powertrainAtom';
import { gearIdAtom } from 'atoms/gearAtom';
import { GEAR_IDS } from 'utils/constsHev';

export const MatrixViewer: React.FC = () => {
    const [activeTab, setActiveTab] = useAtom(matrixTabAtom);
    const config = useAtomValue(stageConfigAtom);
    const powertrain = useAtomValue(powertrainAtom);
    const [gearId, setGearId] = useAtom(gearIdAtom);

    const selectedPath = [
        config.project_id,
        config.destination_id,
        config.lot_id,
        config.phase_id,
        config.calculation_id
    ].filter(id => id).join(' / ');

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
                達成度判断 表/グラフ表示
            </Typography>

            {selectedPath ? (
                <>
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        選択中の既存計算セット：{selectedPath}
                    </Typography>
                    {/* HEV は gear 単位で表示する（BEV では非表示） */}
                    {powertrain === 'hev' && (
                        <FormControl sx={{ mb: 2, maxWidth: 240 }}>
                            <InputLabel id="matrix-gear-select-label">Gear</InputLabel>
                            <Select
                                labelId="matrix-gear-select-label"
                                value={gearId ?? ''}
                                label="Gear"
                                onChange={e => setGearId(e.target.value as string)}
                            >
                                {GEAR_IDS.map(g => (
                                    <MenuItem key={g} value={g}>{g}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </>
            ) : (
                <>
                    <Typography variant="subtitle1" sx={{ mb: 1, color: 'error.main' }}>
                        既存計算セットが選択されていません。
                    </Typography>
                    <Button
                        component={Link}
                        to="/l-tools/existing-project"
                        variant="outlined"
                        size="small"
                        sx={{ mb: 2 }}
                    >
                        計算セットを選択する
                    </Button>
                </>
            )}

            <Tabs value={activeTab} onChange={handleChange} textColor="primary" indicatorColor="primary">
                <Tab label="達成度判断表" />
                <Tab label="個別グラフ表示" />
            </Tabs>

            <Box sx={{ mt: 3 }}>
                {activeTab === 0 && (
                    <Box>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Typography variant="h4">マトリックス表示</Typography>
                            <DownloadMatrixCsvButton />
                        </Box>
                        <AllConditionMatrix />
                    </Box>
                )}
                {activeTab === 1 && (
                    <Box>
                        <Typography variant="h4">条件全体表示</Typography>
                        <AllConditionChart />
                    </Box>
                )}
            </Box>
        </Box>
    );
};
